import React from "react";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

const renderStatus = (state) => {
  if (!state) return <Chip label="Unknown" size="small" />;

  switch (state.toUpperCase()) {
    case "PENDING":
      return (
        <Chip
          icon={<PendingActionsIcon />}
          label="Queued"
          color="default"
          size="small"
          variant="outlined"
        />
      );
    case "RUNNING":
      return (
        <Chip
          icon={<CircularProgress size={16} color="inherit" />}
          label="Processing"
          color="info"
          size="small"
          sx={{
            fontWeight: 600,
            animation: "pulse 2s ease-in-out infinite",
            "@keyframes pulse": {
              "0%, 100%": { boxShadow: "0 0 0 0 rgba(41,182,246,0.4)" },
              "50%": { boxShadow: "0 0 0 6px rgba(41,182,246,0)" },
            },
          }}
        />
      );
    case "SUCCESS":
    case "FINISHED":
      return (
        <Chip
          icon={<CheckCircleOutlineIcon />}
          label="Completed"
          color="success"
          size="small"
        />
      );
    case "FAILED":
    case "FAILURE":
      return (
        <Chip
          icon={<ErrorOutlineIcon />}
          label="Failed"
          color="error"
          size="small"
        />
      );
    case "REVOKED":
    case "CANCELED":
      return (
        <Chip
          icon={<CancelOutlinedIcon />}
          label="Canceled"
          color="warning"
          size="small"
        />
      );
    default:
      return <Chip label={state} size="small" variant="outlined" />;
  }
};

export default renderStatus;
